// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Feedback-space1-X4QlB {
	margin-bottom: 6px !important;
}

.Feedback-space2-ikHfX {
	margin-bottom: 12px !important;
}

.Feedback-space3-R4nNe {
	margin-bottom: 18px !important;
}

.Feedback-space4-RqXTZ {
	margin-bottom: 24px !important;
}

.Feedback-space5-mWZay {
	margin-bottom: 30px !important;
}

.Feedback-space6-iDXQD {
	margin-bottom: 36px !important;
}

.Feedback-space7-CPYYl {
	margin-bottom: 42px !important;
}

.Feedback-spaceTop8-GuA_r {
	margin-bottom: 48px !important;
}

.Feedback-spaceTop1-bdpfn {
	margin-top: 6px !important;
}

.Feedback-spaceTop2-laFS0 {
	margin-top: 12px !important;
}

.Feedback-spaceTop3-nQL5U {
	margin-top: 18px !important;
}

.Feedback-spaceTop4-MNUWU {
	margin-top: 24px !important;
}

.Feedback-spaceTop5-qY4ZT {
	margin-top: 30px !important;
}

.Feedback-spaceTop6-MJ8AC {
	margin-top: 36px !important;
}

.Feedback-spaceTop7-it3S1 {
	margin-top: 42px !important;
}

.Feedback-spaceTop8-GuA_r {
	margin-top: 48px !important;
}

.Feedback-noMargin-A5N02 {
	margin: 0px !important;
}

.Feedback-padding1-_CZfk {
	padding-bottom: 6px !important;
}

.Feedback-padding2-pzcs7 {
	padding-bottom: 12px !important;
}

.Feedback-padding3-cgY4R {
	padding-bottom: 18px !important;
}

.Feedback-padding4-AdLns {
	padding-bottom: 24px !important;
}

.Feedback-padding5-SoG33 {
	padding-bottom: 30px !important;
}

.Feedback-padding6-uuRob {
	padding-bottom: 36px !important;
}

.Feedback-padding7-SoGNE {
	padding-bottom: 42px !important;
}

.Feedback-paddingTop1-Qj0sU {
	padding-top: 6px !important;
}

.Feedback-paddingTop2-tz6OJ {
	padding-top: 12px !important;
}

.Feedback-paddingTop3-oljW9 {
	padding-top: 18px !important;
}

.Feedback-paddingTop4-OHoVp {
	padding-top: 24px !important;
}

.Feedback-paddingTop5-pgb3N {
	padding-top: 30px !important;
}

.Feedback-paddingTop6-j3xYT {
	padding-top: 36px !important;
}

.Feedback-paddingTop7-JQ3X9 {
	padding-top: 42px !important;
}

.Feedback-noPadding-EbPH9 {
	padding: 0px !important;
}

.Feedback-textBold-q1H4F {
	font-weight: 500 !important;
}

.Feedback-textBolder-sa70W {
	font-weight: 700 !important;
}

.Feedback-textNormal-Ee5A5 {
	font-weight: normal !important;
}

.Feedback-spaceBottom20-dS0Pv {
	margin-bottom: 20px;
}

.Feedback-spaceBottom10-VwjvL {
	margin-bottom: 10px;
}

.Feedback-marginNone-Xh6Gb {
	margin: 0;
}

.Feedback-spaceBottom15-hJ2qE {
	margin-bottom: 15px;
}

.Feedback-marginTopNone-rSvqD {
	margin-top: 0;
}

.Feedback-spaceTop11-N0t_r {
	margin-top: 11px;
}

.Feedback-spaceTop21-lJRtS {
	margin-top: 21px;
}

.Feedback-spaceTop20-E51Q1 {
	margin-top: 20px;
}

.Feedback-spaceTop10-YUUC9 {
	margin-top: 10px;
}

/*New Design Text Colors */

.Feedback-textDarkBlue-hodQA {
	color: rgb(20, 39, 94) !important;
}

.Feedback-textLightBlue-F_1Z3 {
	color: rgb(57, 87, 106) !important;
}

.Feedback-textLightSandleGreen-ChU2A {
	color: rgb(76, 86, 41) !important;
}

.Feedback-textLightBrown-M32ww {
	color: rgb(115, 79, 33) !important;
}

.Feedback-textMediumMaroon-Z0nQN {
	color: rgb(87, 37, 51) !important;
}

.Feedback-textBrown-WQghJ {
	color: rgb(160, 47, 24) !important;
}

.Feedback-textMaroon-k8lGw {
	color: rgb(155, 49, 67) !important;
}

.Feedback-textDarkBrown-tlbV2 {
	color: rgb(83, 18, 16) !important;
}

.Feedback-textMediumBrown-vKSc4 {
	color: rgb(142, 28, 10) !important;
}

.Feedback-textSkyBlue-l7Zb8 {
	color: rgb(37, 117, 141) !important;
}

.Feedback-textGray-CDalt {
	color: rgb(77, 65, 51) !important;
}

.Feedback-root-Zwdi4 {
	color: var(--primary-foreground);
	padding: 0px;
}

.Feedback-container-ynCq4 {
	margin: 0 auto;
	width: 100%;
	max-width: 1274px;
	display: block;
}

.Feedback-feedbackContainer-jD58M {
	width: 100%;
	max-width: 1274px;
	margin: 0 auto;
}

.Feedback-feedbackRow-c6Uls {
	display: grid;
	grid-template-columns: 31% 31% 31%;
	grid-gap: 40px;
	background: var(--tertiary-gray-bg);
	border-radius: 22px;
	padding: 80px 68px;
}

.Feedback-feedbackBox-F9wqd {
	padding: 0px 30px 0 0px;
	border-right: 1px solid var(--primary-border);

}

.Feedback-feedbackBox-F9wqd:last-child {
	border-right: 0;
}

.Feedback-feedbackIcon-xMrT8 {
	font-size: 33px;
	height: 33px;
	width: 33px;
	line-height: 20px;
	color: var(--primary-bg);
}

.Feedback-landingLabel-PTclK {
	font-size: 20px;
	font-weight: 700;
	display: block;
	margin-bottom: 5px;
	line-height: 1;
}

.Feedback-landingCaption-o3neC {
	font-size: 16px;
	font-weight: normal;
	line-height: 1.43;
	padding-top: 10px;
	font-weight: 500;
	margin: 0;
	color: var(--secondary-foreground);

}

.Feedback-feedbackContent-EmRBz {
	margin-top: 22px;
}

.Feedback-flex-idpYW {
	display: grid;
	grid-template-columns: 52px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

@media (max-width:1023px) and (min-width:768px) {
	.Feedback-feedbackRow-c6Uls {
		padding: 40px 35px;
	}
}

@media screen and (max-width: 767px) {
	.Feedback-feedbackRow-c6Uls {
		grid-template-columns: 100%;
		padding: 30px;
	}

	.Feedback-feedbackBox-F9wqd {
		padding: 0;
		border-right: 0;
	}

	.Feedback-root-Zwdi4 {
		margin-bottom: 60px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Feedback/Feedback.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,gCAAgC;CAChC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,cAAc;CACd,mCAAmC;CACnC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,6CAA6C;;AAE9C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,SAAS;CACT,kCAAkC;;AAEnC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,2BAA2B;EAC3B,aAAa;CACd;;CAEA;EACC,UAAU;EACV,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.root {\n\tcolor: var(--primary-foreground);\n\tpadding: 0px;\n}\n\n.container {\n\tmargin: 0 auto;\n\twidth: 100%;\n\tmax-width: 1274px;\n\tdisplay: block;\n}\n\n.feedbackContainer {\n\twidth: 100%;\n\tmax-width: 1274px;\n\tmargin: 0 auto;\n}\n\n.feedbackRow {\n\tdisplay: grid;\n\tgrid-template-columns: 31% 31% 31%;\n\tgrid-gap: 40px;\n\tbackground: var(--tertiary-gray-bg);\n\tborder-radius: 22px;\n\tpadding: 80px 68px;\n}\n\n.feedbackBox {\n\tpadding: 0px 30px 0 0px;\n\tborder-right: 1px solid var(--primary-border);\n\n}\n\n.feedbackBox:last-child {\n\tborder-right: 0;\n}\n\n.feedbackIcon {\n\tfont-size: 33px;\n\theight: 33px;\n\twidth: 33px;\n\tline-height: 20px;\n\tcolor: var(--primary-bg);\n}\n\n.landingLabel {\n\tfont-size: 20px;\n\tfont-weight: 700;\n\tdisplay: block;\n\tmargin-bottom: 5px;\n\tline-height: 1;\n}\n\n.landingCaption {\n\tfont-size: 16px;\n\tfont-weight: normal;\n\tline-height: 1.43;\n\tpadding-top: 10px;\n\tfont-weight: 500;\n\tmargin: 0;\n\tcolor: var(--secondary-foreground);\n\n}\n\n.feedbackContent {\n\tmargin-top: 22px;\n}\n\n.flex {\n\tdisplay: grid;\n\tgrid-template-columns: 52px auto;\n\talign-items: center;\n}\n\n@media (max-width:1023px) and (min-width:768px) {\n\t.feedbackRow {\n\t\tpadding: 40px 35px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.feedbackRow {\n\t\tgrid-template-columns: 100%;\n\t\tpadding: 30px;\n\t}\n\n\t.feedbackBox {\n\t\tpadding: 0;\n\t\tborder-right: 0;\n\t}\n\n\t.root {\n\t\tmargin-bottom: 60px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Feedback-space1-X4QlB`,
	"space2": `Feedback-space2-ikHfX`,
	"space3": `Feedback-space3-R4nNe`,
	"space4": `Feedback-space4-RqXTZ`,
	"space5": `Feedback-space5-mWZay`,
	"space6": `Feedback-space6-iDXQD`,
	"space7": `Feedback-space7-CPYYl`,
	"spaceTop8": `Feedback-spaceTop8-GuA_r`,
	"spaceTop1": `Feedback-spaceTop1-bdpfn`,
	"spaceTop2": `Feedback-spaceTop2-laFS0`,
	"spaceTop3": `Feedback-spaceTop3-nQL5U`,
	"spaceTop4": `Feedback-spaceTop4-MNUWU`,
	"spaceTop5": `Feedback-spaceTop5-qY4ZT`,
	"spaceTop6": `Feedback-spaceTop6-MJ8AC`,
	"spaceTop7": `Feedback-spaceTop7-it3S1`,
	"noMargin": `Feedback-noMargin-A5N02`,
	"padding1": `Feedback-padding1-_CZfk`,
	"padding2": `Feedback-padding2-pzcs7`,
	"padding3": `Feedback-padding3-cgY4R`,
	"padding4": `Feedback-padding4-AdLns`,
	"padding5": `Feedback-padding5-SoG33`,
	"padding6": `Feedback-padding6-uuRob`,
	"padding7": `Feedback-padding7-SoGNE`,
	"paddingTop1": `Feedback-paddingTop1-Qj0sU`,
	"paddingTop2": `Feedback-paddingTop2-tz6OJ`,
	"paddingTop3": `Feedback-paddingTop3-oljW9`,
	"paddingTop4": `Feedback-paddingTop4-OHoVp`,
	"paddingTop5": `Feedback-paddingTop5-pgb3N`,
	"paddingTop6": `Feedback-paddingTop6-j3xYT`,
	"paddingTop7": `Feedback-paddingTop7-JQ3X9`,
	"noPadding": `Feedback-noPadding-EbPH9`,
	"textBold": `Feedback-textBold-q1H4F`,
	"textBolder": `Feedback-textBolder-sa70W`,
	"textNormal": `Feedback-textNormal-Ee5A5`,
	"spaceBottom20": `Feedback-spaceBottom20-dS0Pv`,
	"spaceBottom10": `Feedback-spaceBottom10-VwjvL`,
	"marginNone": `Feedback-marginNone-Xh6Gb`,
	"spaceBottom15": `Feedback-spaceBottom15-hJ2qE`,
	"marginTopNone": `Feedback-marginTopNone-rSvqD`,
	"spaceTop11": `Feedback-spaceTop11-N0t_r`,
	"spaceTop21": `Feedback-spaceTop21-lJRtS`,
	"spaceTop20": `Feedback-spaceTop20-E51Q1`,
	"spaceTop10": `Feedback-spaceTop10-YUUC9`,
	"textDarkBlue": `Feedback-textDarkBlue-hodQA`,
	"textLightBlue": `Feedback-textLightBlue-F_1Z3`,
	"textLightSandleGreen": `Feedback-textLightSandleGreen-ChU2A`,
	"textLightBrown": `Feedback-textLightBrown-M32ww`,
	"textMediumMaroon": `Feedback-textMediumMaroon-Z0nQN`,
	"textBrown": `Feedback-textBrown-WQghJ`,
	"textMaroon": `Feedback-textMaroon-k8lGw`,
	"textDarkBrown": `Feedback-textDarkBrown-tlbV2`,
	"textMediumBrown": `Feedback-textMediumBrown-vKSc4`,
	"textSkyBlue": `Feedback-textSkyBlue-l7Zb8`,
	"textGray": `Feedback-textGray-CDalt`,
	"root": `Feedback-root-Zwdi4`,
	"container": `Feedback-container-ynCq4`,
	"feedbackContainer": `Feedback-feedbackContainer-jD58M`,
	"feedbackRow": `Feedback-feedbackRow-c6Uls`,
	"feedbackBox": `Feedback-feedbackBox-F9wqd`,
	"feedbackIcon": `Feedback-feedbackIcon-xMrT8`,
	"landingLabel": `Feedback-landingLabel-PTclK`,
	"landingCaption": `Feedback-landingCaption-o3neC`,
	"feedbackContent": `Feedback-feedbackContent-EmRBz`,
	"flex": `Feedback-flex-idpYW`
};
module.exports = ___CSS_LOADER_EXPORT___;
